<!--Header Start Here-->
<header class="header">
  <!-- <div id="claimheader"> -->
  <div>
    <div class="top-header" [ngClass]="!isUserLogin ? 'hide' : ''">
      <div class="spacing-mob container max-width-1180">
        <div class="row margin-right-sm-0">
          <div
            class="col-sm-12 d-flex justify-content-end"
            *ngIf="isDataAvailable"
          >
            <!-- Example single danger button -->
            <div class="nav-ancillary" *ngIf="!isUserLogin">
              <ul>
                <li class="nav-item">
                  <a routerLink="/request-access">{{
                    headerData.topHeaderLinks[0].displayItems[0].keyText
                  }}</a>
                </li>
                <li class="nav-item">
                  <a href="https://www.tmhcc.com" target="_blank">{{
                    headerData.topHeaderLinks[0].displayItems[1].keyText
                  }}</a>
                </li>
              </ul>
            </div>

            <div class="" *ngIf="isUserLogin">
              <div class="btn-group profile-dropdown">
                <a
                  href="javascript:void(0);"
                  class="btn dropdown-toggle header-user-name"
                  aria-haspopup="true"
                  aria-expanded="false"
                  (click)="showLogout = true; popupLogoutOnClick = true"
                >
                  {{ headerData.topHeaderLinks[0].displayItems[2].keyText }}
                  <span id="headerUserName">{{ loggedInUser }}</span>
                  <i
                    aria-hidden="true"
                    class="fa fa-chevron-down custom-icon"
                  ></i>
                </a>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  [ngClass]="{ show: showLogout }"
                  (clickOutside)="closeLogoutPopup($event)"
                >
                  <a
                    class="dropdown-item"
                    href="javascript:void(0);"
                    (click)="welcomeLink(item.keyText)"
                    *ngFor="
                      let item of topHeaderDropdownList
                    "
                  >
                    <span>{{ item.keyText }}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container max-width-1180 spacing-mob">
      <nav class="navbar navbar-expand-md navbar-light custom-navbar top-nav">
        <a (click)="headerLink('BaseUrl')" class="navbar-brand"></a>
        <button
          *ngIf="!isUserLogin"
          class="navbar-toggler top-navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target=".navbar-collapse"
          aria-controls="navbarCollapse"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div
          *ngIf="isDataAvailable"
          class="collapse navbar-collapse justify-content-end top-coll"
        >
          <div class="main-nav main-mob-nav" *ngIf="!isUserLogin">
            <ul *ngIf="isDataAvailable" class="customer">
              <li class="nav-claims" (click)="openModal()">
                <a href="javascript:void(0)" class="ls-modal">
                  {{ customerService[0].keyText }}</a
                >
              </li>
            </ul>

            <ul class="display login-top-link">
              <li class="nav-item">
                <a routerLink="/request-access">{{
                  headerData.topHeaderLinks[0].displayItems[0].keyText
                }}</a>
              </li>
              <li class="nav-item">
                <a href="https://www.tmhcc.com" target="_blank">{{
                  headerData.topHeaderLinks[0].displayItems[1].keyText
                }}</a>
              </li>
            </ul>
          </div>
        </div>

        <button
          *ngIf="isUserLogin"
          class="navbar-toggler top-navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarCollapse"
          aria-controls="navbarCollapse"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div
          *ngIf="isDataAvailable"
          class="collapse navbar-collapse top-space justify-content-end"
          id="navbarCollapse"
        >
          <ul class="navbar-nav" *ngIf="isUserLogin">
            <li
              class="nav-item"
              *ngFor="let item of headerData.mainLinks[0].displayItems"
            >
              <a
                *ngIf="item.keyText == 'New Quote'"
                href="javascript:void(0);"
                class="nav-link active"
                [ngClass]="{ activeTab: showQuotes }"
                aria-haspopup="true"
                aria-expanded="false"
                (click)="
                  showQuotes = true;
                  popupsubMenuOnClick = true;
                  stopMenuClose($event)
                "
              >
                {{ item.keyText }} 
                <i
                  aria-hidden="true"
                  class="fa fa-chevron-down custom-icon font-size-15"
                ></i>
              </a>
              <a
                *ngIf="item.keyText != 'New Quote'"
                href="javascript:void(0);"
                (click)="headerLink(item.keyText)"
                class="nav-link active"
              >
                {{ item.keyText }} 
              </a>
            </li>
          </ul>

          <div
            class="dropdown-menu transparent-bg"
            [ngClass]="{ show: showQuotes }"
          >
            <div class="dropdown-bg"></div>
            <div
              class="dropdown-submenu sub-menu-right col-sm-12 col-lg-8"
              (clickOutside)="closeNewClaimPopup($event)"
            >
              <div class="row neg-margin8">
                <span
                  class="cross-icon cus-cross"
                  (click)="closeNewClaimPopup($event)"
                  >×</span
                >
                <div class="col-sm-12 col-lg-6 gray-bg" *ngIf="isDataAvailable">
                  <h2 class="width80">
                    {{ headerData.headerDropdown[0].heading }}
                  </h2>
                  <ul class="new-claim-list">
                    <li
                      *ngFor="let item of productList"
                      (click)="
                        newQuote(
                          item.Name,
                          item.PolicyTypeId,
                          item.SubCompanyCode
                        );
                        closeNewClaimPopup($event)
                      "
                    >
                      <div class="sub-menu-link">
                        <div class="float-left">
                          <img src="{{ item.imageSrc }}" />
                        </div>
                        <div class="dropdown-link float-left">
                          <a href="javascript:void(0)"
                            >{{ item?.Name }}
                            <span>&nbsp;</span>
                          </a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div
                  class="col-sm-12 col-lg-6 product-info"
                  *ngIf="isDataAvailable"
                >
                  <h2 class="pad-left0">
                    {{ headerData.headerDropdown[1].heading }}
                  </h2>
                  <div
                    (click)="closeNewClaimPopup($event)"
                    *ngFor="
                      let item of headerData.headerDropdown[1].displayItems
                    "
                  >
                    <a [href]="item.navigation.Url +'?v=1'" target="_blank">{{
                      item.keyText
                    }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </div>

  <section class="login-label" *ngIf="!dashboardFlag">
    <div class="container">
      <div class="row">
        <div class="col-sm-12 padding0" *ngIf="isDataAvailable">
          <h1>{{ headerData.mainLinks[0].heading }}</h1>
        </div>
      </div>
    </div>
  </section>
</header>
<!--/. Header End Here-->

<ac-loader *ngIf="isLoading" [loaderMessage]="'Loading..'"></ac-loader>
<ac-custom-popup-alert></ac-custom-popup-alert>
<ng-container
  *ngIf="'artisan' !== this.currentUrl; then generalLiability; else artisan"
>
</ng-container>

<ng-template #artisan>
  <router-outlet></router-outlet>
</ng-template>

<!--Step Menu Starts-->
<ng-template #generalLiability>
  <div class="container margin-bot400 margin-top40 overflow-sm">
    <div class="row">
      <ae-general-info-tabs
        [summarySitecoreData]="summaryContent"
        [summaryApiData]="summaryPanel"
        style="width: 100%;"
        *ngIf="summaryFlag"
      >
      </ae-general-info-tabs>
    </div>

    <!--Under Writer Message-->
    <div
      *ngIf="uwMessageFlag && summaryPanel?.SummaryDetails.SummaryPendingItem"
      class="row"
    >
      <div class="uw-message-box">
        <img
          src="../assets/images/info-icon.png"
          alt="UNDERWRITER MESSAGE"
          align="left"
        />
        <h1>MESSAGE FROM UNDERWRITER</h1>
        <p>
          {{
            summaryPanel.SummaryDetails.SummaryPendingItem
              .SubmissionStatusDescription
          }}
        </p>
      </div>
    </div>

    <!-- Pending Underwriter Review -->
    <div *ngIf="refralMessageFlag" class="row">
      <div class="uw-message-box">
        <img
          src="../assets/images/info-icon.png"
          alt="UNDERWRITER MESSAGE"
          align="left"
        />
        <h1>REASON FOR REFERRAL</h1>
        <p [innerHTML]="submissionDescription"></p>
        <!-- <p
          [innerHTML]="
            summaryPanel.SummaryDetails.SummaryPendingItem
              .SubmissionStatusDescription
          "
        ></p> -->
      </div>
    </div>

    <!-- <ae-page-step-nav></ae-page-step-nav> -->
    <div class="row">
      <div class="col-12 col-md-3 padding0">
        <accordion [options]="options" [menus]="menus"></accordion>
      </div>
      <div class="col-12 col-md-9 padding0 padding-left20">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</ng-template>
<!--Step Menu Ends-->

<!--Footer Starts Here-->
<footer-page></footer-page>
<!--/. Footer End Here-->
